import React from 'react';

import { FieldErrorParserResultInterface } from 'utils/fieldErrorParser';

import './LabelWithErrors.scoped.scss';

interface Props {
  errorInfo: FieldErrorParserResultInterface;
  label: React.ReactNode;
}

const LabelWithErrors: React.FC<Props> = ({ label, errorInfo }) => {
  return (
    <div>
      {(label || errorInfo.showFirstError) && (
        <div>
          {label && <span className="title">{label}</span>}
          {errorInfo.showFirstError && <span className="error">{errorInfo.firstError}</span>}
        </div>
      )}
    </div>
  );
};

export default LabelWithErrors;
